import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

import { IconType } from 'react-icons/lib';

import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';

import { usePages } from '../../hooks/Pages';
import { useLanguage } from '../../hooks/Language';
import SlideList from '../DashboardPages/features/SliderComponent';
import ProjectList from '../DashboardPages/features/ProjectList';
import EventList from '../DashboardPages/features/EventsList';
import api from '../../services/api';
import { authTitle, hash, supportNumber, urlWebsite } from '../../config';
import { Button } from '../../components/Button/styles';
import SliderContainer from '../../components/SliderContainer';
import { FaBrain, FaSearch, FaStar } from 'react-icons/fa';
import Calendar from './modules/Calendar';
import SelectSimple from '../../components/Forms/SelectSimple';
import EventsListDisplay from '../DashboardPages/features/EventsListDisplay';
import PosterListDisplay from '../DashboardPages/features/PosterListDisplay';
import TestimonialListDisplay from '../DashboardPages/features/TestimonialDisplay';
import { ContactIcons, ContactIconsOrange } from '../../components/Menu';
import themeDefault from '../../styles/ThemeComponents';
import Whatsapp from '../../components/Whatsapp';
import SponsorsOnDemand from '../SponsorsOnDemand';
import SliderHeaderComponent from '../DashboardPages/features/SlidePosterHeader';
import { loadFromJson } from '../../utils/loadFromJson';

interface IMenu {
  title: string;
  target: string;
  targetID: string;
  fluid: number;
  external: number;
  status: number;
}

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home2: React.FC = () => {

  const { setMenu } = usePages();
  const { setAvailableLanguages } = useLanguage();
  const { translate } = useLanguage();
  const lorem = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.';
  const { addModal, removeModal } = useModal();
  const [slides, setSlides] = useState<Array<JSX.Element>>([]);


  const [search, setSearch] = useState('');
  const [currentCategory, setCurrentCategory] = useState('');
  const sendToEvents = () => {

    let link = currentCategory ? `/eventos` : `/eventos`;

    if (search) {
      link = `${link}?search=${encodeURIComponent(search)}`;
    }

    window.location.href = link;

  }

  const loadConfig = async () => {

    let data: Record<string, any> = {};

    const item = await loadFromJson({ hash: hash, project_id: 'global', table: 'Global' })


    if (!item) {
      const config = await api.get('/get_platform');

      data = config.data;
    }
    else {
      data = item?.[0] || {}
    }




    if (data.slides) {
      const slideJSX: Array<JSX.Element> = [];

      data.slides.map(s => {
        slideJSX.push(s.link_url ? <a href={s.link_url}><img src={`${urlWebsite}/${s.url}`} style={{ width: '100%' }} /></a> : <img src={`${urlWebsite}/${s.url}`} style={{ width: '100%' }} />)
      })

      setSlides(slideJSX);



    }

    const menu: Array<IMenu> = [];

    try {
      data?.menu.map((m: IMenu) => {
        m.fluid = parseInt(m.fluid.toString(), 10);
        m.status = parseInt(m.status.toString(), 10);
        m.external = parseInt(m.external.toString(), 10);

        menu.push(m);
      })

      setMenu(menu);

    }
    catch (err) {
      console.log('Error on define Menu');
    }


    setAvailableLanguages(data?.languages || []);




  }

  useEffect(() => {
    loadConfig();
    /*
        addModal({
       key:'popup',
       theme: 'whiteModal2',
       title:' ',
       content: <><div style={{width:'100%', maxWidth:'500px', margin: '0px auto'}}>
         <Link onClick={() => removeModal('popup')} style={{width:'100%', maxWidth:'500px', margin: '0px auto'}} to="/app/sessao-clinica-hospitais-dasa-brasil/login">
           <img src="/apoio/sessao-clinica.png" style={{width:'100%', maxWidth:'500px', margin: '0px auto'}}/>
         </Link>
         </div></>
     }  ) */
  }, [])


  const sponsors = [
    { url: '/sponsors/1.png', link_url: 'https://www.world-stroke.org/' },
    { url: '/sponsors/2.png', link_url: 'http://www.redebrasilavc.org.br/' },
    { url: '/sponsors/3.png', link_url: '' },
    { url: '/sponsors/4.png', link_url: 'https://www.abneuro.org.br/' },
    { url: '/sponsors/5.png', link_url: 'http://sbdcv.org.br/' },
    { url: '/sponsors/6.png', link_url: '' },
    { url: '/sponsors/7.png', link_url: 'https://sbnr.org.br/' },
    { url: '/sponsors/8.png', link_url: 'https://www.svin.org/' },
    { url: '/sponsors/9.png', link_url: 'https://abeneuro.org.br/' },
    { url: '/sponsors/10.png', link_url: 'https://abavc.org.br/' },
    { url: '/sponsors/11.png', link_url: 'http://sbth.org.br/' },
    { url: '/sponsors/12.png', link_url: 'https://amavc.com.br/' },
    { url: '/sponsors/13.png', link_url: 'https://www.acaoavc.org.br/' },
    { url: '/sponsors/14.png', link_url: '' },

  ]


  const handle = () => { }

  return (<>
    <Container>
      <Capa style={{ minHeight: 'auto', marginBottom: '25px', display: 'none' }}>
        <div className='p50 homeTitle'>

          <h2>Sejam bem-vindos ao</h2>
          <h2 className='bigger'>Programa de Educação Virtual da</h2>
          <h2 className='bigger'>Rede Brasil AVC</h2>

        </div>
        <div className='p50  '>
          <div className='searchDiv'>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <input value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  sendToEvents();
                }
              }} className='homeSelect' name="search" placeholder='Pesquisar' />

              <button onClick={() => sendToEvents()} type="button" className='homeSelectReverse'><FaSearch /></button>
            </div>
          </div>
        </div>
      </Capa>

      <Capa  >

        <div style={{ width: '100%', margin: '0px', marginBottom: '30px' }}>

          <div className='homeTitle'>
            <h2>Sejam bem-vindos ao</h2>
            <h2 className='bigger'>Programa de Educação Virtual da</h2>
            <h2 className='bigger'>Rede Brasil AVC</h2>
          </div>

          <EventsListDisplay showLinks allowed={['next','lives', 'courses']} />

        </div>
        <div style={{ width: '100%', maxWidth: '650px', position: 'relative' }}  >
          {/* <h2 style={{ marginBottom: '15px' }}>Confira nossa agenda</h2>
            <Calendar /> */}


          <div style={{ width: '100%', maxWidth: '450px', position: 'relative' }}  >
            <h2 className='greenButton' style={{ position: 'absolute', top: '-20px', left: '50%', transform: 'translateX(-50%)', zIndex: 10 }}>DESTAQUES</h2>
            <SliderHeaderComponent poster_id='63763f077f8d869f7b28f662' />

          </div>
          <div style={{ width: '100%' }} >
            <SponsorsOnDemand limit={6} />
          </div>
        </div>

      </Capa>



    </Container>
    <Whatsapp className="fixedWhatsapp greenButton buttonEdge computerOnly" number={supportNumber} message="Suporte técnico" text={`Olá, estou no ${authTitle}`} />
    <Whatsapp className="  greenButton mobileOnly" number={supportNumber} message="Suporte técnico" text={`Olá, estou no ${authTitle}`} />

  </>
  );
};
export default Home2;
